import { bl_fi_fixed_asset_register_hdr_RowClass, bl_fi_fixed_asset_register_import_file_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class AssetRegisterImportFileHdrContainerModel extends BaseContainerModel {
  bl_fi_fixed_asset_register_import_file_hdr: bl_fi_fixed_asset_register_import_file_hdr_RowClass = new bl_fi_fixed_asset_register_import_file_hdr_RowClass();
}

